module.exports = __webpack_public_path__ + "img/2.78715c78.jpg";